/**
 * "Reconnecting…" banner shown over a call overlay while the media connection is
 * transiently re-establishing (Chime auto-reconnect). Accessible: announced via
 * an assertive live region so screen-reader users hear the connection wobble.
 */
export function CallReconnectingBanner({ show }: { show: boolean }) {
  if (!show) return null
  return (
    <div
      className="pointer-events-none absolute inset-x-0 top-[max(1rem,var(--safe-top))] z-[64] flex justify-center px-4"
      role="alert"
      aria-live="assertive"
    >
      <span className="flex items-center gap-2 rounded-full bg-amber-500/95 px-4 py-2 text-sm font-semibold text-amber-950 shadow-lg">
        <span
          className="h-3.5 w-3.5 animate-spin rounded-full border-2 border-amber-900/40 border-t-amber-900"
          aria-hidden
        />
        Reconnecting…
      </span>
    </div>
  )
}
